import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const UPPER = () => {
  return (
    <CardSection id="UPPER" title="UPPER">
      <Paragraph>열의 텍스트를 모두 대문자로 변환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>UPPER(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 대문자로 변환할 문자열 또는 열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>UPPER(`product`)</Paragraph>
        <Img src="computeUpper" />
      </ListSection>
    </CardSection>
  );
};
